import React from "react";
import { ReferenceFieldProps } from "./types";
import { getReferenceConfig } from "./config";
import { RealtimeSearchStrategy } from "./strategies/RealtimeSearchStrategy";
import { FrontendFilterStrategy } from "./strategies/FrontendFilterStrategy";

export const ReferenceField: React.FC<ReferenceFieldProps> = ({
  value,
  onChange,
  referenceEntity,
  disabled = false,
  className = "",
  error = false,
  required = false,
}) => {
  const config = getReferenceConfig(referenceEntity);

  if (!config) {
    return (
      <div className="text-red-500">Invalid reference entity configuration</div>
    );
  }

  if (config.searchStrategy === "realtime") {
    return (
      <RealtimeSearchStrategy
        value={value}
        onChange={onChange}
        referenceEntity={referenceEntity}
        placeholder={config.placeholder}
        searchMinLength={config.searchMinLength || 2}
        searchDelay={config.searchDelay || 500}
        disabled={disabled}
        error={error}
        className={className}
      />
    );
  }

  if (config.searchStrategy === "frontend") {
    return (
      <FrontendFilterStrategy
        value={value}
        onChange={onChange}
        referenceEntity={referenceEntity}
        component={config.component}
        placeholder={config.placeholder}
        disabled={disabled}
        error={error}
        className={className}
      />
    );
  }

  // Fallback - should never reach here with our current config
  return <div>Unsupported reference entity type</div>;
};
